import { Button, makeStyles } from "@material-ui/core";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import LaunchIcon from "@material-ui/icons/Launch";

const useStyles = makeStyles((theme) => ({
  container: {
    margin: "0 10px 0 10px",
  },
  button: {
    textTransform: "capitalize",
    fontWeight: 600,
  },
}));

const RedirectToButton = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const { pathname: previousPath } = location;

  const { config } = props;
  const {
    key: configKey,
    displayName,
    redirectTo,
    newTab,
    sameDomain,
    icon,
  } = config;

  const handleRedirect = (link, openInNewTab, sameDomain) => {
    if (openInNewTab) {
      window.open(link, "_blank");
    } else if (sameDomain === false) {
      window.location.href = link;
    } else {
      history.push({
        pathname: link,
        state: {
          previousPath,
        },
      });
    }
  };

  return (
    <div className={classes.container}>
      <Button
        className={classes.button}
        onClick={() => handleRedirect(redirectTo, newTab, sameDomain)}
        size="large"
        startIcon={icon}
        endIcon={configKey !== "financial" ? <LaunchIcon /> : <></>}
      >
        {displayName}
      </Button>
    </div>
  );
};

export default RedirectToButton;
